/** @file Keeps the mix preview's picked pair on its animations as the working document changes. */
import type { Doc, Id } from '@pose2d/format/types';
import { mixPreviewStore } from './mixPreviewStore';

/** `id` in `next`; else the animation `next` holds under the name `id` had in `prev` (a client id the server
 *  confirmed under its own id); else null (deleted). */
function follow(id: Id | null, prev: Doc | null, next: Doc): Id | null {
  if (id === null || next.animations[id] !== undefined) return id;
  const name = prev?.animations[id]?.name;
  return name === undefined ? null : (Object.entries(next.animations).find(([, anim]) => anim.name === name)?.[0] ?? null);
}

/** Rewrites mixPreviewStore.from/to for the step from `prev` to `next` (nothing when both still exist). */
export function followMixPair(prev: Doc | null, next: Doc): void {
  const s = mixPreviewStore.getState();
  const from = follow(s.from, prev, next);
  const to = follow(s.to, prev, next);
  if (from !== s.from || to !== s.to) mixPreviewStore.setState({ from, to });
}
